<template>
  <div class="custom-icon" :class="icon">
    <!-- PNG Sprite Icon -->
    <png-sprite-icon
      v-if="sprite"
      :icon="icon"
      :sprite="sprite"
      :sprite-sheet-width="spriteSheetWidth"
      :sprite-sheet-height="spriteSheetHeight"
      :width="width"
      :height="height"
      :disabled="disabled"
      :color="color"
    />
    <!-- Regular Icon -->
    <img
      v-else-if="!editableColor"
      :width="width"
      :height="height"
      :src="imageUrl"
      :class="{ disabled: disabled }"
      alt="pointr-icon"
    />
    <svg-filler
      v-else
      :width="width"
      :height="height"
      :src="imageUrl"
      :class="{ disabled: disabled }"
      :path="imageUrl"
      :fill="parsedColor"
      :stroke="parsedStrokeColor"
    />
  </div>
</template>

<script>
import SvgFiller from "@/helpers/SvgFiller";
import PngSpriteIcon from "./PngSpriteIcon.vue";
import colors from "@/assets/colors.js";

export default {
  name: "PtrIcon",
  components: {
    SvgFiller,
    PngSpriteIcon
  },

  props: {
    editableColor: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String
    },
    sprite: {
      type: String,
      default: null
    },
    spriteSheetWidth: {
      type: Number,
      default: 2048
    },
    spriteSheetHeight: {
      type: Number,
      default: 2048
    },
    width: {
      type: [Number, String]
    },
    height: {
      type: [Number, String]
    },
    disabled: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: "#9095A2"
    },
    strokeColor: {
      type: String,
      default: "none"
    },
    extension: {
      type: String,
      default: "svg"
    },
    rounded: {
      type: Boolean
    }
  },

  computed: {
    imageUrl() {
      return require(`@/assets/custom-icons/${this.icon}.${this.extension}`);
    },

    parsedColor() {
      return this.parseColorValue(this.color);
    },

    parsedStrokeColor() {
      return this.parseColorValue(this.strokeColor);
    }
  },

  methods: {
    parseColorValue(colorString) {
      // If it's a hex color or 'none', return as is
      if (colorString === "none" || colorString.startsWith("#")) {
        return colorString;
      }

      // Parse color reference like "foreground-darken2"
      const [palette, variant] = colorString.split("-");

      // Check if the palette exists
      const generatedColors = colors();
      if (generatedColors[palette]) {
        // If variant exists in the palette, return that color
        if (generatedColors[palette][variant]) {
          return generatedColors[palette][variant];
        }
        // If no variant specified, return base color
        if (!variant) {
          return generatedColors[palette].base;
        }
      }

      // Return the original string if no matching color found
      return colorString;
    }
  }
};
</script>
<style lang="scss">
.custom-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  user-select: none;

  .disabled {
    filter: grayscale(1) opacity(0.5);
  }
}

.selected {
  // .custom-icon,
  // span {
  //   filter: brightness(0) invert(1);
  // }

  &:active {
    .custom-icon,
    span {
      filter: none;
    }
  }
}
</style>
